import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface BulkMessageSelectionState {
  idsByCode: Partial<Record<string, number[]>>;
}

const initialState: BulkMessageSelectionState = {
  idsByCode: {},
};

const bulkMessageSelectionSlice = createSlice({
  name: 'bulkMessageSelection',
  initialState,
  reducers: {
    setBulkMessageCustomerIds: (
      state,
      action: PayloadAction<{
        bulkMessageCode: string;
        customerIds: number[];
      }>,
    ) => {
      state.idsByCode[action.payload.bulkMessageCode] =
        action.payload.customerIds;
    },
    clearBulkMessageCustomerIds: (state, action: PayloadAction<string>) => {
      state.idsByCode[action.payload] = [];
    },
  },
});

export const { setBulkMessageCustomerIds, clearBulkMessageCustomerIds } =
  bulkMessageSelectionSlice.actions;

export const bulkMessageSelectionReducer = bulkMessageSelectionSlice.reducer;
